import { styled } from '@mui/material/styles';

import theme from '~/theme/';

export const StyledSmartAnswerText = styled<any>('p')`
  width: 100%;
  font-size: 1rem;
  color: ${theme.colors.gray[600]};
  font-style: italic;
`;

export const StyledHeading = styled<any>('div')(
  ({ isSectionHeader = false, isPlain = false, isCompact = false }) => ({
    borderBottom: `1px solid ${theme?.colors?.black}`,
    padding: '0.25rem 0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '1rem',
    fontWeight: '500',
    width: '100%',
    textAlign: 'left',
    marginBottom: '1rem',
    ...(isSectionHeader && {
      borderBottom: `3px solid ${theme?.colors?.uwmLogo?.blue}`,
      color: theme?.colors?.uwmLogo?.blue,
      padding: '0.5rem 0',
      fontSize: '1.5rem',
      textIndent: '1rem',
    }),
    ...(isPlain && {
      borderBottom: 'none',
      color: theme?.colors?.black,
      textIndent: 0,
    }),
    ...(isCompact && {
      padding: 0,
      marginBottom: '0.25rem',
    }),
  }),
);
